import { Row, Col, CardBody } from 'react-bootstrap';

import TopCourseEnrollments from 'pages/insights/containers/analyticsSummaryContainer/components/topCourseEnrollments';
import TopCourseCompletions from 'pages/insights/containers/analyticsSummaryContainer/components/topCourseCompletions';

import UserAnalytics from 'pages/dashboard/containers/Analytics';
import UserSite from 'pages/dashboard/containers/sites';
import AnalyticsHeader from 'pages/dashboard/containers/AnalyticHeader';

const Dashboard = () => {
  return (
    <>
      <UserSite />
      <AnalyticsHeader />
      <div className="card-area p-4">
        <CardBody>
          <UserAnalytics />
          <Row className="dashboard-course-stats">
            <Col xs="12" lg="6">
              <div className="stats-box mb-4 mb-lg-0">
                <TopCourseEnrollments />
              </div>
            </Col>
            <Col xs="12" lg="6">
              <div className="stats-box">
                <TopCourseCompletions />
              </div>
            </Col>
          </Row>
        </CardBody>
      </div>
    </>
  );
};

export default Dashboard;
